import { Icon } from '@iconify/react'
import classNames from 'classnames'

import type { TeamMember } from 'features/TeamChat/api/teamChat.types'
import { TEAM_COPY } from 'features/TeamChat/teamChat.constants'
import styles from 'features/TeamChat/teamChat.module.scss'

import { MemberAvatar } from '../MemberAvatar'
import { AlertCircleIcon, ChevronUpIcon, CloseIcon } from '../TeamIcons'

type Props = {
  open: boolean
  chips: TeamMember[]
  helpBusy: boolean
  onToggle: () => void
  onPick: (member: TeamMember) => void
  onHelp: () => void
  onCancel?: () => void
  cancelDisabled?: boolean
}

const CHIPS_ID = 'team-mention-chips'

// The design's tablet bar: wrapping teammate chips, then Mention, help and, for a new request, close.
export const MentionBar = ({
  open,
  chips,
  helpBusy,
  onToggle,
  onPick,
  onHelp,
  onCancel,
  cancelDisabled,
}: Props) => (
  <div className={styles.mentionBar}>
    {open && chips.length > 0 && (
      <div id={CHIPS_ID} role='group' aria-label={TEAM_COPY.MENTION_LIST} className={styles.chips}>
        {chips.map((m) => (
          <button
            key={m.id}
            type='button'
            className={styles.memberChip}
            // Keeps the caret in the message box so the name lands where it was being typed.
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onPick(m)}>
            <MemberAvatar user={m} />
            <span>{m.handle}</span>
          </button>
        ))}
      </div>
    )}
    <div className={styles.barActions}>
      <button
        type='button'
        aria-expanded={open}
        aria-controls={CHIPS_ID}
        className={classNames(styles.barButton, { [styles.barButtonOn]: open })}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onToggle}>
        <span className={styles.at}>@</span>
        <span>{TEAM_COPY.MENTION}</span>
        <ChevronUpIcon />
      </button>
      <button
        type='button'
        className={classNames(styles.barButton, styles.helpButton)}
        aria-busy={helpBusy || undefined}
        disabled={helpBusy}
        onClick={onHelp}>
        {helpBusy ? (
          <Icon icon='lucide:loader-circle' width={16} className={styles.spin} aria-hidden='true' />
        ) : (
          <AlertCircleIcon />
        )}
        <span>{TEAM_COPY.NEED_HELP}</span>
      </button>
      {onCancel && (
        <button
          type='button'
          className={styles.barClose}
          aria-label={TEAM_COPY.CANCEL_REQUEST}
          title={TEAM_COPY.CANCEL_REQUEST}
          disabled={cancelDisabled}
          onClick={onCancel}>
          <CloseIcon />
        </button>
      )}
    </div>
  </div>
)
